import { useState } from 'react'

import { Flex } from '@chakra-ui/react'
import _ from 'lodash'
import { ItListItem, ItListItemType } from 'types/graphql'

import BrandButton from 'src/components/widgets/buttons/BrandButton'
import ErrorMessage from 'src/components/widgets/ErrorMessage/ErrorMessage'
import Input, { InputValue } from 'src/components/widgets/Input/Input'
import InterceptKey from 'src/components/widgets/InterceptKey/InterceptKey'
import { capitalize, enforceHttps, isValidUrl } from 'src/lib/utils'
import { BrandColor } from 'src/types'

export type ScraperProps = {
  onBeforeUpdate?: (item: ItListItem) => ItListItem
  hasError?: boolean
  children: React.ReactNode
}

type PrefillProps = {
  itemType: ItListItemType
  creatorBrandColor: BrandColor
  hasError: boolean
  onClick: (url: string) => void
}

export const Prefill: React.FC<PrefillProps> = ({
  creatorBrandColor,
  itemType,
  hasError,
  onClick,
}) => {
  const [prefillUrl, setPrefillUrl] = useState('')

  const changeHandler = (newValue: string) => {
    try {
      const urlWithProtocol = enforceHttps(newValue)
      setPrefillUrl(urlWithProtocol)
    } catch (err: unknown) {
      setPrefillUrl(newValue)
    }
  }

  const clickHandler = () => {
    setPrefillUrl('')
    onClick(prefillUrl)
  }
  const isDisabled = !isValidUrl(prefillUrl)
  return (
    <InterceptKey keyName="Enter" onKeyPressed={clickHandler}>
      <Flex mt={4} w="full" flexDirection="row" justifyContent="space-between">
        <Input
          type="url"
          w="full"
          onChange={(value: InputValue) => {
            changeHandler(value as string)
          }}
          maxLength={2000}
          data-testid="scraper-urlInput"
          name="prefillUrl"
          shouldRegister={false}
          placeholder={`${capitalize(itemType || 'item')} URL`}
        />
        <BrandButton
          // Seems like the disabled attribute appears in the browser but not in Cypress
          data-testid={`scraper-submitUrl${isDisabled ? '-disabled' : ''}`}
          ml={4}
          width="44px"
          height="44px"
          isDisabled={isDisabled}
          _disabled={{ color: 'graphite' }}
          brandColor={isDisabled ? 'vapor' : creatorBrandColor}
          onClick={clickHandler}
        >
          Go
        </BrandButton>
      </Flex>
      {hasError && (
        <ErrorMessage message="Please enter and submit a valid URL" mt={2} />
      )}
    </InterceptKey>
  )
}

export default Prefill
